export const cacheKeys = {
  getOngoingFeedbackSession: 'getOngoingFeedbackSession',
  answerFeedbackQuestion: 'answerFeedbackQuestion',
};
